import { Link } from "react-router-dom";
import type { PepLocale } from "../../i18n/types";

interface ProductFinalCtaBandProps {
  locale: PepLocale;
  productName: string;
  primary: { to: string; label: string };
  secondary?: { to: string; label: string };
}

export function ProductFinalCtaBand({
  locale,
  productName,
  primary,
  secondary,
}: ProductFinalCtaBandProps) {
  return (
    <section className="pep-pd-final" aria-labelledby="pep-pd-final-title">
      <div className="container pep-pd-final__inner">
        <h2 id="pep-pd-final-title" className="pep-pd-final__title">
          {locale === "en"
            ? `Ready to modernize your school with ${productName}?`
            : `Prêt à moderniser votre établissement avec ${productName} ?`}
        </h2>
        <p className="pep-pd-final__body">
          {locale === "en"
            ? "Configure your environment, explore editions, or talk to our team for a guided demo."
            : "Configurez votre environnement, explorez les éditions, ou échangez avec notre équipe pour une démonstration guidée."}
        </p>
        <div className="pep-pd-final__ctas">
          <Link className="btn pep-pd-btn-primary pep-pd-btn-primary--on-dark" to={primary.to}>
            {primary.label}
          </Link>
          {secondary ? (
            <Link className="btn pep-pd-btn-ghost pep-pd-btn-ghost--on-dark" to={secondary.to}>
              {secondary.label}
            </Link>
          ) : null}
        </div>
      </div>
    </section>
  );
}
